const data = {
  getReports: []
}

export default {
  namespaced: true,
  strict: process.env.NODE_ENV === 'development',
  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Set the form data.
     *
     * @param {*} state
     * @param {*} data
     */
    setData (state, data) {
      state.getReports = data
    },

    /**
       * Reset all state.
       * @param {*} state
       */
    reset (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    }
  }
}
